// --- Flag context types (discriminated union) ---

/** Dashboard format: event-based flags stored raw in DB */
export interface EventFlagContext {
  event_uuid: string;
  event_type_key: string;
  match_timestamp?: string;
}

/** Standard format: entity-based flags built by create_flag_context_jsonb_object */
export interface EntityFlagContext {
  uuid?: string;
  entity_uuid: string;
  entity_key: string;
  app_translation_key?: string;
  external_url?: string | null;
  external_url_label?: string | null;
}

/** Accounts-based flags (e.g. negative_total_equity) */
export interface AccountsFlagContext {
  accounts_uuid: string;
  total_equity?: number;
  accounting_year?: number;
}

/** External URL flags (e.g. authorization_sentral_godkjenning, mesterbedrift) */
export interface ExternalUrlFlagContext {
  external_url: string;
  external_url_label?: string;
  mester_profession?: string;
}

/** Collateral flags (e.g. has_collateral) */
export interface CollateralFlagContext {
  collateral_count: number;
  latest_registration_date?: string;
}

export type CompanyFlagContext =
  | EventFlagContext
  | EntityFlagContext
  | AccountsFlagContext
  | ExternalUrlFlagContext
  | CollateralFlagContext;

export function isEventContext(ctx: CompanyFlagContext): ctx is EventFlagContext {
  return 'event_type_key' in ctx;
}

export function isEntityContext(ctx: CompanyFlagContext): ctx is EntityFlagContext {
  return 'entity_key' in ctx;
}

export function isAccountsContext(ctx: CompanyFlagContext): ctx is AccountsFlagContext {
  return 'accounts_uuid' in ctx && !('entity_key' in ctx);
}

export function isExternalUrlContext(ctx: CompanyFlagContext): ctx is ExternalUrlFlagContext {
  return 'external_url' in ctx && !('entity_key' in ctx) && !('event_type_key' in ctx);
}

export function isCollateralContext(ctx: CompanyFlagContext): ctx is CollateralFlagContext {
  return 'collateral_count' in ctx;
}
